import script from "./SearchAndSortWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchAndSortWindow.vue?vue&type=script&setup=true&lang=ts"

import "./SearchAndSortWindow.vue?vue&type=style&index=0&id=54e6eb94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e6eb94"]])

export default __exports__